import { translate } from '@/domains/core/localization/translate';
import type { ProductCondition, ProductSecondHandContext } from '@/domains/sustainability/secondHand/utils/secondHand';
export const {
  secondHandLabel
} = translate({
  "secondHandLabel": "Seconde vie"
});
export const conditionTranslations = translate<ProductCondition>({
  "GOOD": "good condition",
  "VERY_GOOD": "very good condition"
});
export const contextTranslations = translate<ProductSecondHandContext>({
  "USED": "Used",
  "NEVER_USED": "Never used",
  "REFURBISHED": "Refurbished"
});
export const conditionModalTranslations = translate<ProductCondition>({
  "GOOD": "May show visible signs of wear.",
  "VERY_GOOD": "May show very slight signs of wear."
});
export const contextModalTranslations = translate<ProductSecondHandContext>({
  "USED": "Our products in perfect working condition but used briefly.",
  "NEVER_USED": "Products in perfect working condition, generally speaking, this category concerns obsolete products or products with slight imperfections or whose packaging is damaged or missing.",
  "REFURBISHED": "Products that have been purchased and used by their first buyer. These products have been reconditioned by repair professionals to replace certain parts and then tested to validate their perfect working condition."
});